import * as WordCloud from "wordcloud";

const COLORS = [
    '#FF0000',
    '#FFFF00',
    '#00FFFF',
    '#00FF00',
    '#0000FF',
    '#FF00FF',
    '#F08080',
    '#FFE4C4',
    '#D2691E',
    '#DC143C',
    '#98FB98',
    '#FF1493',
    '#00BFFF',
    '#DB7093',
    '#4682B4',
    '#87CEFA',
    '#FF00FF',
    '#4169E1',
    '#00CED1',
    '#00FF7F',
    '#B0C4DE',
];

export default {
    COLORS,
    WordCloud,
    cloud (words, {colors}) {
        if (!Array.isArray(colors) || 0 === colors.length) {
            colors = COLORS;
        }

        words.sort((right, left) => left[1] - right[1]);

        const canvasWrapperId = 'open-poll-result';
        const canvasId = 'open-poll-result-canvas';
        const canvasWrapper = document.getElementById(canvasWrapperId);
        const canvas = document.getElementById(canvasId);
        const height = canvasWrapper.offsetHeight;
        const width = canvasWrapper.offsetWidth;
        canvas.height = height;
        canvas.width = width;

        // const topWordLength = words[0][0].length;
        // let maxSize = 150;
        // const minSize = 10;

        const maxWeight = 200;
        const minWeight = 10;

        // if (topWordLength > 25) {
        //     maxSize = 20;
        // } else if (topWordLength > 20) {
        //     maxSize = 30;
        // } else if (topWordLength > 15) {
        //     maxSize = 40;
        // } else if (topWordLength > 10) {
        //     maxSize = 50;
        // } else if (topWordLength >= 5) {
        //     maxSize = 80;
        // }

        const maxSize = words[0][1];
        // const mul = (maxSize - minSize) / maxWeight;
        let i = 0;

        WordCloud(canvas, {
            list: words,
            rotateRatio: 0,
            shuffle: false,
            shrinkToFit: true,
            abortThreshold: 1500,
            backgroundColor: 'transparent',
            color: (word, weight, fontSize, distance, theta) => {
                return colors[i++ % colors.length];
            },
            weightFactor: (size) => {
                let weight = size / maxSize * maxWeight;
                if (weight < minWeight) {
                    weight = minWeight
                }
                return weight;
            },
            // weightFactor: (size) => Math.round(size * mul),
        });

        const context = canvas.getContext('2d');
        context.clearRect(0, 0, canvas.width, canvas.height);
    }
}
